import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '@/hooks/useCookieConsent';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const useGoogleAnalytics = () => {
  const { analytics, hasConsented } = useCookieConsent();
  const location = useLocation();

  // Update consent when user makes a choice
  useEffect(() => {
    if (!hasConsented || !window.gtag) return;

    window.gtag('consent', 'update', {
      analytics_storage: analytics ? 'granted' : 'denied',
    });
  }, [analytics, hasConsented]);

  // Track page views on route change (only if analytics consented)
  useEffect(() => {
    if (!analytics || !window.gtag) return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search, analytics]);
};
